const { debounce } = window.BAO.Utils;

class StickyColumn extends window.BAO.CustomElement() {
  static get requiredElements() {
    return ["sticky"];
  }

  connectedCallback() {
    super.connectedCallback();
    this.initialise();
  }

  setupListeners() {
    super.setupListeners();
    const debouncedDetectHeights = debounce(this.detectHeights.bind(this), 250);

    this.listeners.add(window, "resize", debouncedDetectHeights.bind(this));
  }

  initialise() {
    this.detectHeights();
  }

  detectHeights() {
    const top = this.viewportHeight - this.elementHeight;
    const headerHeight = window.matchMedia("(min-width: 1201px)")?.matches
      ? this.externalEls?.header?.element?.offsetHeight || 0
      : 0;

    this.els.sticky.element.style.setProperty(
      "top",
      `${top < headerHeight ? top : headerHeight}px`,
    );
  }

  get viewportHeight() {
    return Math.max(
      document.documentElement.clientHeight || 0,
      window.innerHeight || 0,
    );
  }

  get elementHeight() {
    return this.els.sticky.element.scrollHeight;
  }
}

if (!customElements.get("sticky-column")) {
  customElements.define("sticky-column", StickyColumn);
}
